// Static sample data for the Self vs Others divergence table. Each entry is one
// category with the person's own rating (`self`) and the averaged "all but self"
// rating (`others`). The gap (self − others) drives the marker positions and the
// status chip; nothing here is fetched yet.
export const DIVERGENCE_DATA = [
    { category: 'Team Development', self: 4, others: 3.44 },
    { category: 'Inclusion', self: 5.22, others: 4.00 },
    { category: 'Self-Awareness', self: 5.88, others: 5.26 },
    { category: 'Collaboration', self: 6, others: 5.16 },
    { category: 'High Performance Team', self: 5.11, others: 5.12 },
    { category: 'Coaching', self: 5.09, others: 5.09 },
];


export const CHIP = {
    BLIND_SPOT: { label: 'Blind Spot', modifier: 'blind-spot' },
    HIDDEN_STRENGTH: { label: 'Hidden Strength', modifier: 'hidden-strength' },
    SLIGHT_GAP: { label: 'Slight Gap', modifier: 'slight-gap' },
    ALIGNED: { label: 'Aligned', modifier: 'aligned' },
};

export const chipForGap = (severity) => {

    return CHIP[severity] ? CHIP[severity] : {}
};

// Position of a rating value along the org's scale (1..6 or 1..4, see
// utils/scaleConfig) as a 0..100 percentage.
export const scalePct = (value, scale) =>
    ((value - scale.min) / (scale.max - scale.min)) * 100;

// Signed gap (self − others) formatted with an explicit +/− and two decimals.
export const formatDelta = (gap) => {
    const sign = gap > 0 ? '+' : gap < 0 ? '−' : '';
    return `${sign}${Math.abs(gap).toFixed(2)}`;
};


export const HEADER_TEXT = {
    title: "Self vs. Others perception",
    description: 'Where self-ratings diverge from how stakeholders rate the same behaviors.'
}